import { emptySplitApi } from "./baseApi";

export type SourceKey =
  | "VMS"
  | "ODOO"
  | "GOOGLE_SHEETS"
  | "PASTEL"
  | "CANDY"
  | "MS365";

export interface AssistantSource {
  key: SourceKey;
  label: string;
  description: string;
  connected: boolean;
}

export interface Lookup {
  id: string;
  system: "VMS" | "ODOO" | "GOOGLE_SHEETS";
  record: string;
  query: string;
  retrievedAt: string;
  asOf?: string;
  lastModifiedBy?: string;
  count: number;
  truncated: boolean;
  rows: Record<string, unknown>[];
  error?: string;
}

export interface ChatAnswer {
  conversationId: string;
  content: string;
  lookups: Lookup[];
  followUps: string[];
}

export interface ConversationSummary {
  id: string;
  title?: string;
  channel: "web" | "whatsapp";
  updatedAt?: string;
}

export interface StoredMessage {
  role: "user" | "assistant";
  content: string;
  createdAt: string;
  lookups?: Lookup[];
  followUps?: string[];
}

export const aiAssistantApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    getAiAssistantSources: build.query<
      { readOnly: boolean; sources: AssistantSource[] },
      void
    >({
      query: () => ({ url: "/ai-assistant/sources" }),
    }),
    getAiAssistantConversations: build.query<ConversationSummary[], void>({
      query: () => ({ url: "/ai-assistant/conversations" }),
    }),
    getAiAssistantConversation: build.query<
      { id: string; messages: StoredMessage[] },
      string
    >({
      query: (id) => ({ url: `/ai-assistant/conversations/${id}` }),
    }),
    postAiAssistantChat: build.mutation<
      ChatAnswer,
      { question: string; conversationId?: string }
    >({
      query: (body) => ({ url: "/ai-assistant/chat", method: "POST", body }),
    }),
  }),
});

export const {
  useGetAiAssistantSourcesQuery,
  useGetAiAssistantConversationsQuery,
  useLazyGetAiAssistantConversationQuery,
  usePostAiAssistantChatMutation,
} = aiAssistantApi;
